import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { workforceSolutionsFeatureKey, reducer } from './workforce-solutions.reducer';
import { WorkforceSolutionsEffects } from './effects/workforce-solutions.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(workforceSolutionsFeatureKey, reducer),
        EffectsModule.forFeature([WorkforceSolutionsEffects])
    ]
})
export class WorkforceSolutionsStoreModule {}
